import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { array, number, string, bool, object } from "prop-types";
import { Link } from "@quintype/components";
import { getCategoryAndSubCategory, getTemplateName } from "../../../ga-utils";

import { Button, TableWidget } from "../../atoms";
// import { SvgIconHandler } from "../../atoms/SvgIconHandler";
import { useTrackWidgetImpression } from "../../../ga-utils";
import { HOME_PAGE_RANKING_DESCRIPTIONS } from "../../../../../config/entity-ranking-descriptions";

import "./RankingTableWidget.m.css";

const RankingTableWidget = ({
  headline,
  year,
  subHeadline,
  buttonText,
  logoLink,
  href,
  tBodyData,
  tHeadData,
  customClassName,
  storyPage = false,
  story = {},
}) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = get(qtState, ["pageType"], "");
  const config = get(qtState, ["config"], {});
  const linkCategory = `${headline} ${year}`;
  const isBrowser = typeof window !== "undefined";

  // Use the custom hook for tracking widget impressions
  const componentRef = useTrackWidgetImpression(
    {
      sectionName: `${headline} ${year}`,
      pageType: pageType,
      location: isBrowser ? window.location : null,
      config: config,
      story,
      threshold: 0.2,
    },
    { disabled: !isBrowser }
  );

  // Track ranking widget click events
  const trackRankingWidgetClick = () => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(
        window.location,
        pageType,
        config,
        story
      );
      window.dataLayer.push({
        event: "dl_ranking_widget_click",
        link_text: buttonText.toLowerCase(),
        link_category: linkCategory.toLowerCase(),
        category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(story?.["story-template"] || pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };
  if (storyPage) {
    return (
      <div styleName="ranking-table-widget-wrapper ranking-table-widget-wrapper-storyPage" ref={componentRef}>
        <div styleName="ranking-table-widget ranking-table-widget-storyPage">
          <div styleName="left-section top-section">
            <div styleName="logo-button">
              <img loading="lazy" styleName="logo" src={logoLink} alt="logo" width="200" height="81" title="logo" />
              <div styleName="heading">{`${headline} ${year}`}</div>
              <Button href={href} isEventConfigured={true} onClickFunction={trackRankingWidgetClick}>
                {buttonText}
              </Button>
            </div>
            <p styleName="sub-headline">{HOME_PAGE_RANKING_DESCRIPTIONS[headline]}</p>
          </div>
          <TableWidget customStyleName={customClassName} tBodyData={tBodyData} tHeadData={tHeadData} />
        </div>
        <Link href={href} styleName="link" disableAjaxLinks={true} onMouseDown={trackRankingWidgetClick}>
          {buttonText}
          {/* <SvgIconHandler styleName="arrow" type="arrow" width="24px" height="24px" viewBox="0 0 24 24" /> */}
        </Link>
      </div>
    );
  }
  return (
    <div styleName="ranking-table-widget-wrapper" ref={componentRef}>
      <div styleName="ranking-table-widget">
        <div styleName="left-section">
          <img loading="lazy" styleName="logo" src={logoLink} alt="logo" width="200" height="81" title="logo" />
          <div styleName="heading">{`${headline} ${year}`}</div>
          <p styleName="sub-headline">{HOME_PAGE_RANKING_DESCRIPTIONS[headline]}</p>
          <Button href={href} isEventConfigured={true} onClickFunction={trackRankingWidgetClick}>
            {buttonText}
          </Button>
        </div>
        <TableWidget customStyleName={customClassName} tBodyData={tBodyData} tHeadData={tHeadData} />
      </div>
      <Link href={href} styleName="link" disableAjaxLinks={true} onMouseDown={trackRankingWidgetClick}>
        {buttonText}
        {/* <SvgIconHandler styleName="arrow" type="arrow" width="24px" height="24px" viewBox="0 0 24 24" /> */}
      </Link>
    </div>
  );
};

RankingTableWidget.defaultProps = {
  headline: "",
  subHeadline: "",
  buttonText: "",
  logoLink: "",
  href: "",
  tBodyData: [],
  tHeadData: [],
  year: 2000,
  customClassName: "",
};

RankingTableWidget.propTypes = {
  headline: string,
  subHeadline: string,
  buttonText: string,
  storyPage: bool,
  logoLink: string,
  href: string,
  tBodyData: array,
  tHeadData: array,
  year: number,
  customClassName: string,
  pageType: string,
  config: object,
};

export default RankingTableWidget;
